import React from 'react';
import PropTypes from 'prop-types';
import Grid from '@mui/material/Grid';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import Skeleton from '@mui/material/Skeleton';
import { InformationTooltip } from '../tooltips';

const DrawerHeader = ({ title, subtitle, headerTooltipText, loading, titleColor }) => (
  <Grid sx={{ marginBottom: 3 }}>
    <Stack direction="row" spacing={1}>
      {loading ? (
        <Skeleton variant="text" width={200} height={24} />
      ) : (
        <Typography variant="h4" color={titleColor}>
          {title}
        </Typography>
      )}
      {headerTooltipText && <InformationTooltip title={headerTooltipText} />}
    </Stack>
    {subtitle
      && (
      <Typography variant="h2" color="text.highlight">
        {subtitle}
      </Typography>
      )}
  </Grid>
);

DrawerHeader.propTypes = {
  title: PropTypes.string.isRequired,
  subtitle: PropTypes.string,
  headerTooltipText: PropTypes.string,
  loading: PropTypes.bool,
  titleColor: PropTypes.string,
};

DrawerHeader.defaultProps = {
  subtitle: null,
  headerTooltipText: null,
  loading: false,
  titleColor: 'text.highlight',
};

export default DrawerHeader;
